// Query-tab "scraps" — the editor content of CLOSED query tabs, kept per user for
// ~7 days so an accidental close can be recovered from the Scrap sidebar tab.
import { api } from './api.js';

export const listScraps = () => api.get('/api/me/scraps').then((r) => r.scraps || []);

// scrap: { title, database, connectionId, sqlText }. Empty sqlText is ignored
// server-side, so callers can fire-and-forget on every tab close.
export const addScrap = (scrap) => api.post('/api/me/scraps', scrap);

export const deleteScrap = (id) => api.delete(`/api/me/scraps/${id}`);
